import React, { useEffect, useState } from "react";
import { Container, Draggable } from 'react-smooth-dnd';
import uuid from 'react-uuid'
import { GetComponent } from "../admin/Components/Components"
import { Modal } from "antd";

export default function DropArea(props) {

    const { containerRef = { current: false }, getGlobals = () => { }, updateGlobals = () => { }, globals = [], setGlobals = () => { }, globalTarget = false, view = "desktop", setView = () => {}, menus = [], selected = "", setSelected = () => { }, page, location, open = true, updateContent = () => { }, content = [], setContent = () => { }, setEditing = () => { }, editing = false, getContent = () => { } } = props;
    const [canAccept, setCanAccept] = useState(false)

    const preDrop = (e) => {

        if(e.addedIndex === null){ return;}
        if(e.payload && e.payload.group === "custom_html_css"){
            Modal.confirm({
                title : <>Warning! </>,
                okText : "Agree & Continue",
                content : <>Custom HTML and CSS  or Custom Embed can create unintended consequences and has the potential to break your site, including product searching, browsing, and customer check out. <div className="shim" /> Bookmanager support staff are unable to troubleshoot or assist with your code, or assist with broken website functionality as a result of using custom code. <div className="shim" />Use this option at your own risk, or better yet, contact Bookmanager support to see if there is an alternate approach.</>,
                onOk : () => {
                    onDrop(e)
                }
            })
        } else {
            onDrop(e)
        }
    }

    const onDrop = (e) => {

        if (!canAccept) {
            return false;
        }

        let { removedIndex, addedIndex, payload } = e

        if (payload) {
            // add
            let tmp = [...items];
            tmp.splice(addedIndex, 0, {
                page: page,
                location: location,
                id: uuid(),
                start_date: 0,
                end_date: 0,
                visibility: "test", // visible, test, hidden
                expiry_action: false,
                container: payload.container,
                name : (payload.label === "Blank Space") ? payload.label : "",
                component: payload.key,
                type: payload.type,
                can_delete: true,
                data: payload.data
            });

            setItems(tmp);
            updateContent(tmp, location);
        } else {
            // reposition
            let tmp = [...items];
            let moved = tmp[removedIndex];
            tmp = tmp.filter((i, ind) => ind !== removedIndex);
            setItems([...tmp.slice(0, addedIndex), moved, ...tmp.slice(addedIndex)])
            updateContent([...tmp.slice(0, addedIndex), moved, ...tmp.slice(addedIndex)], location);
        }

    }

    const [items, setItems] = useState([])


    useEffect(() => {
        setItems([...content]);
    }, [content])


    const saveItem = (_id, _item, _from_id = false) => {

        if (_id === "search_bar" || _id === "nav_bar" || _id === "footer_bar") {
            // Bypass regular save and use prefs.
            let global_copy = [...globals];
            let c = global_copy.findIndex(item => item.component === _id);

            if (c > -1) {                
                global_copy[c].data = _item.data;
                global_copy[c].container = _item.container;
                updateGlobals(global_copy, "global");
            }
            return;
        }

        let tmp_array = [...items];

        if (_from_id) {
            // find the index of the id to be duplicated
            let _from_ind = tmp_array.findIndex((item) => item.id === _from_id)
            // add the new item at this index
            tmp_array.splice(_from_ind+1, 0, _item);
        }
        let ind = tmp_array.findIndex((item) => item.id === _id)
        tmp_array[ind] = _item;
        setItems(tmp_array);
        updateContent(tmp_array, location);
    }

    const deleteItem = (_id) => {
        let tmp = items.filter((item) => item.id !== _id);
        setItems(tmp);
        updateContent(tmp, location);
    }

    let _color = (globalTarget) ? "#ee8219" : "#19acee";
    let _class = (globalTarget) ? "global-target" : "page-target";
    let _style = {
        border: (items.filter(item => item.can_delete).length === 0 && open) ? "1px dashed" + _color : "none",
        marginBottom: (items.length === 0 && open) ? "2px" : "0px",
        minHeight: (open) ? "calc(100vh - 320px)" : "0px"
    }

    return (<>
        <div>
            <div className={(items.filter(item => item.can_delete).length === 0 && open) ? "target " + _class : "target"}>

                <Container
                    onDragEnter={() => setCanAccept(true)}
                    onDragLeave={() => setCanAccept(false)}
                    onDragEnd={() => setTimeout(() => { setCanAccept(false) }, 1)}
                    style={_style}
                    dropPlaceholder={{ animationDuration: 0, showOnTop: true, className: 'drop-preview' }}
                    dragHandleSelector=".dragHandle" lockAxis="y"
                    groupName={"1"}
                    onDrop={preDrop}>
                    {items.filter(item => item.location === location).map((item, i) => {

                        if (item.component === "search_bar" || item.component === "nav_bar" || item.component === "footer_bar") {
                            return (<div key={i} style={{ "display": "none" }}><GetComponent menus={menus} getContent={getContent} page={page} view={view} selected={selected} setSelected={setSelected} setEditing={setEditing} editing={editing} name={item.component} id={i} meta={{ content: item, id: item.id, full: true, deleteItem: deleteItem, saveItem: saveItem }} open={open} /></div>)
                        }
                        return (
                            <Draggable key={item.id}>
                                <div>
                                    <div><GetComponent items={items} containerRef={containerRef} getGlobals={getGlobals} getContent={getContent} page={page} updateGlobals={updateGlobals} globals={globals} setGlobals={setGlobals} view={view} setView={setView} menus={menus} setContent={setContent} selected={selected} setSelected={setSelected} setEditing={setEditing} editing={editing} name={item.component} id={i} meta={{ content: item, id: item.id, full: true, deleteItem: deleteItem, saveItem: saveItem }} open={open} /></div>
                                </div>
                            </Draggable>
                        );
                    })}
                </Container>
            </div>
        </div>

    </>)
}